import React, { useContext } from 'react';
import { Button, Col, Form, Input, Row } from 'antd';
import './styles.less';
import PropTypes from 'prop-types';
import tokens from '../../../../../../../utils/tokens';
import { EnrollmentFormContext } from '../../../../../../../providers/EnrollmentFormContextProvider';
import form from '../../../../../../../utils/form';

const CollapseForm = ({ deliverableType }) => {
  const { enrollmentForm } = useContext(EnrollmentFormContext);

  const initialValues = {
    deliverablesDestinataries: {
      [deliverableType]: [{}],
    },
  };

  return (
    <Row className="swiftForm">
      <Col span={24}>
        <Form
          form={enrollmentForm}
          initialValues={initialValues}
          layout="vertical"
          validateMessages={form.validateMessages}
        >
          <Form.List name={['deliverablesDestinataries', deliverableType]}>
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, fieldKey, ...restField }) => (
                  <React.Fragment key={key}>
                    <Form.Item
                      initialValue={deliverableType}
                      name={[name, 'deliverableType']}
                      fieldKey={[fieldKey, 'deliverableType']}
                      hidden
                    />
                    <Form.Item noStyle={fields.length === 1}>
                      <Row gutter={[tokens.forms.horizontalGutterInPx]}>
                        <Col span={24}>
                          <Form.Item
                            label="Nombre completo"
                            name={[name, 'name']}
                            fieldKey={[fieldKey, 'name']}
                            // rules={[{ required: true }]}
                            {...restField}
                          >
                            <Input />
                          </Form.Item>
                        </Col>
                        <Col lg={12} xs={24}>
                          <Form.Item
                            label="Cargo o Parentesco"
                            name={[name, 'positionOrRelationship']}
                            fieldKey={[fieldKey, 'positionOrRelationship']}
                            // rules={[{ required: true }]}
                            {...restField}
                          >
                            <Input />
                          </Form.Item>
                        </Col>
                        <Col lg={12} xs={24}>
                          <Form.Item
                            label="Correo electrónico"
                            name={[name, 'email']}
                            fieldKey={[fieldKey, 'email']}
                            // rules={[{ required: true, type: 'email' }]}
                            {...restField}
                          >
                            <Input />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Form.Item>
                  </React.Fragment>
                ))}
                <Row gutter={[tokens.forms.horizontalGutterInPx]}>
                  <Col lg={12} xs={23}>
                    <Button
                      className="swiftForm__button"
                      type="dashed"
                      onClick={() =>
                        add({
                          name: '',
                          cargo: '',
                          mail: '',
                        })
                      }
                    >
                      + Agregar otro
                    </Button>
                  </Col>
                  {fields.length > 1 && (
                    <Col lg={12} xs={24}>
                      <Button
                        className="swiftForm__button"
                        type="dashed"
                        onClick={() => remove(fields.length - 1)}
                      >
                        - Eliminar último
                      </Button>
                    </Col>
                  )}
                </Row>
              </>
            )}
          </Form.List>
        </Form>
      </Col>
    </Row>
  );
};

CollapseForm.propTypes = {
  deliverableType: PropTypes.string.isRequired,
};

export default CollapseForm;
